export abstract class PhoneNumberValidator {
  static readonly numberValidator: RegExp = new RegExp('^\\+?\\d+$');

  abstract validateFormattedNumber(number: string): boolean;

  abstract validate(number: string): boolean;

  sanitize(number: string): string | null {
    const sanitizedNumber = number?.replace(' ', '');
    if(sanitizedNumber && PhoneNumberValidator.numberValidator.test(sanitizedNumber)) {
      return sanitizedNumber;
    }

    return null;
  }
}
